import React, { PropsWithChildren } from "react";
import { Box, CircularProgress, Typography } from "@mui/material";

/** Small inline loader (pagination, secondary fetches). Prefer the skeletons in `components/skeletons` for initial page loads. */
export const LoadingBox = ({children}: PropsWithChildren) => {
    return (
        <Box sx={{ color: 'text.secondary', display: 'flex', alignItems: 'center', width: '100%', gap: 1, p: 2, justifyContent: 'center' }}>
            <CircularProgress size={14} thickness={5} color="inherit" />
            <Typography variant="subtitle1" sx={{ color: 'inherit' }}>Chargement…</Typography>
            {children}
        </Box>
    );
};
